import { PROJECT_CATEGORY, SETTLE_MODE, SETTLE_OBJ_TYPE } from './settleConst'

export default {
  /*
    0   按任务   
    1   按答卷数量   元/份
    2   按天   元/天
    3   按阶梯   元/点位
    4   按点位
  */
  filters: {
    getUnit(v, c) {
      switch (v) {
        case SETTLE_MODE.ANSWER_NUMBER:
          return '份'
        case SETTLE_MODE.DAY:
          return '天'
        case SETTLE_MODE.LADDER_PRICING:
          let u = ''
          if (c === PROJECT_CATEGORY.SPOT_INVESTIGATIONS) {
            u = '点位'
          } else if (c === PROJECT_CATEGORY.QUESTIONNAIRE_SURVEY) {
            u = '份'
          }
          return u
        case SETTLE_MODE.POINT_POSITION:
          return '点位'
        default:
          return ''
      }
    }
  },
  data() {
    return {
      mobileReg: /(?=(\d{4})+$)/g
    }
  },
  computed: {
    statementId() {
      return this.$route.query.statementId || this.$route.params.id
    },
    settleObjType() {
      return this.$route.query.settleObjType ?? SETTLE_OBJ_TYPE.INVESTIGATOR
    },
    isInvestigator() {
      return this.settleObjType == SETTLE_OBJ_TYPE.INVESTIGATOR
    }
  },
  methods: {
    handleTime(start, end, format, separator = '~') {
      if (!(start && end)) return '无'
      let s = ''
      let e = ''
      switch (format) {
        case 'HH:mm':
          s = start.substring(start.indexOf(' ') + 1, start.lastIndexOf(':'))
          e = end.substring(end.indexOf(' ') + 1, end.lastIndexOf(':'))
          break
        case 'yyyy-MM-dd':
          s = start.split(' ')[0]
          e = end.split(' ')[0]
          break
        default: //yyyy-MM-dd HH:mm
          s = start.substring(0, start.lastIndexOf(':'))
          e = end.substring(0, end.lastIndexOf(':'))
          break
      }
      return s + ' ' + separator + ' ' + e
    },
    setCardListNum(data) {
      const isInvestigator = data.settleObjType === SETTLE_OBJ_TYPE.INVESTIGATOR
      let list = this.getCardList
      list.forEach(item => {
        data[item.code] ??= 0
        item.value = data[item.code].toFixed(item.valueFixed ?? 0)
        if (item.code === 'linkedProjectNum') {
          item.valueNote = data.linkedImportProjectNum ? `含人工导入${data.linkedImportProjectNum}个` : ''
        } else if (item.code === (isInvestigator ? 'expectedYuanAmount' : 'operationalYuanAmount')) {
          item.valueNote = data.adjustYuanAmount
            ? `含补扣款${data.adjustYuanAmount > 0 ? '+' + data.adjustYuanAmount.toFixed(2) : data.adjustYuanAmount.toFixed(2)}`
            : ''
        } else if (item.code === 'settleObjType') {
          item.value = isInvestigator ? '调查员' : '代理'
        }
      })
    }
  }
}
